import { Tag } from 'antd';
import { formatDate } from 'utils';
import { renderWithTooltip } from 'utils/table';

export const columns = [
  {
    title: 'Заголовок',
    dataIndex: 'title',
    key: 'title',
    render: (value) => renderWithTooltip(value),
  },
  {
    title: 'Описание',
    dataIndex: 'description',
    key: 'description',
    render: (value) => renderWithTooltip(value),
  },
  {
    title: 'Текст',
    dataIndex: 'text',
    key: 'text',
    render: (value) => renderWithTooltip(value),
  },
  {
    title: 'Статус',
    dataIndex: 'is_published',
    key: 'is_published',
    render: (value) => {
      const text = value ? 'Опубликован' : 'Не опубликован';
      const color = value ? 'green' : 'red';

      return <Tag color={color}>{text}</Tag>;
    },
  },
  {
    title: 'Зарегистрирован',
    dataIndex: 'authorized',
    key: 'authorized',
    render: (value) => {
      const text = value ? 'Да' : 'Нет';
      const color = value ? 'green' : 'red';

      return <Tag color={color}>{text}</Tag>;
    },
  },
  {
    title: 'Дата создания',
    dataIndex: 'created_at',
    key: 'created_at',
    render: (date) => formatDate(date),
  },
];
